// "/cadastro"
export const institucionalStyles = {
  formContent: {
    maxWidth: "900px",
    width: "100%",
    px: ["4", "0"],
  },
  heading: {
    color: "gray.800",
    fontWeight: "bold",
    textAlign: "center",
  },
  subheading: {
    fontWeight: "bold",
    color: "gray.600",
    textAlign: "center",
    mb: 2,
  },
  formTitle: {
    bg: "red-wine",
    p: 2,
    color: "white",
    fontSize: "xl",
    position: "relative",
    zIndex: 10,
    fontWeight: "bold",
    textAlign: "center",
    borderTopRadius: "lg",
    justifyContent: "center",
    boxShadow: "sm",
    w: "100%",
  },
  container: {
    bg: "white",
    boxShadow: "sm",
    mx: "auto",
    color: "gray.700",
    fontSize: "sm",
    px: ["4", "20"],
    py: "5",
    borderBottomRadius: "lg",
  },
  headerContainer: {
    bgRepeat: "repeat",
    borderBottom: "1px solid #D0D0D0",
    padding: ["4", "6"],
    py: ["4", "6"],
    textAlign: "center",
    mb: "6",
  },
  headerFlex: {
    align: "center",
    justifyContent: "center",
    direction: "row",
    gap: 3,
    width: "100%",
  },
  headerText: {
    fontFamily: "merriweather",
    fontSize: ["2xl", "3xl", "4xl"],
    color: "gray.800",
    fontWeight: "bold",
    wordBreak: "keep-all",
  },
  grid: {
    columns: { base: 1, md: 2 },
    gap: 6,
    mt: 2,
  },
  buttonBase: {
    color: "white",
    mt: 4,
    // w:['full','auto'],
    alignSelf: "center",
    rounded: "md",
    fontWeight: "bold",
    bg: "red-wine",
    // width:"100%",
    transition: "all 0.2s ease-in-out",

    width: "100%",
    whiteSpace: "normal",
    height: "auto",
    minHeight: "48px",
    py: 4,
    px: 4,
    lineHeight: "shorter",

    _disabled: {
      opacity: 0.6,
      cursor: "not-allowed",
    },
    _hover: {
      // transform: 'scale(1.05)',
      filter: "brightness(0.9)",
    },
    _active: {
      boxShadow: "inner",
    },
  },
  button: {
    bg: "red-wine",
    _hover: {
      backgroundColor: "red.600",
    },
  },
  buttonValid: {
    bg: "green.500",
    _hover: {
      backgroundColor: "green.600",
    },
  },
};

export const contactCardsStyles = {
  container: {
    direction: ["column", "row"],
    mt: 4,
    gap: 6,
    wrap: "wrap",
  },
  card: {
    p: 4,
    borderRadius: "lg",
    boxShadow: "sm",
    bg: "white",
  },
  fitCard: {
    flexShrink: 0,
    width: ["100%", "fit-content"],
  },
  flexCard: {
    flex: 1,
    minW: "250px",
  },
  title: {
    fontWeight: "bold",
    fontSize: "xl",
    color: "gray.800",
    textAlign: "center",
  },
  map: {
    width: "100%",
    height: "250px",
    style: { border: 0, borderRadius: "8px" },
    allowFullScreen: true,
  },
};

export const diretoriaStyles = {
  container: {
    px: ["4", "10", "20"],
    mt: "20",
  },
  mainFlex: {
    direction: ["column", "row"],
    gap: [8, 20],
  },
  tabsWrapper: {
    my: 8,
    bg: "white",
    borderRadius: "lg",
  },
  tabsContainer: {
    alignItems: "center",
    flexDirection: "column",
    width: "full",
  },
  tabsRoot: {
    width: "full",
  },
  tabsList: {
    borderTopRadius: "md",
    borderBottomRadius: "none",
    p: "1",
    bg: "red-wine",
    boxShadow: "sm",
    w: "100%",
    alignContent: "center",
  },
  tabTrigger: {
    color: "white",
    transition: "all 0.4s ease",
    _hover: {
      bg: "red.700",
      transition: "background 0.3s ease",
    },
    _selected: {
      color: "white",
      fontWeight: "bold",
      fontSize: "md",
      bg: "red.600",
      pl: "5",
      _hover: {
        bg: "red.600",
      },
    },
  },
  tabIcon: {
    display: ["none", "block"],
    style: { marginRight: "8px" },
  },
  tabContent: {
    borderBottomRadius: "md",
    borderTopRightRadius: "md",
    boxShadow: "sm",
    pb: "5",
  },
  finalText: {
    fontSize: "md",
    textAlign: "justify",
    mt: 4,
    color: "gray.600",
  },
  memberCard: {
    p: 2,
    borderBottom: "1px solid transparent",
    transition: "all 0.3s ease",
    w: "fit-content",
    _hover: {
      paddingLeft: "10",
      paddingRight: "10",
      borderColor: "red-wine",
    },
  },
  memberName: {
    fontFamily: "merriweather",
    fontWeight: "bold",
    color: "gray.800",
    fontSize: "md",
  },
  memberRole: {
    color: "gray.600",
  },
  grid: {
    columns: [1, 2],
    p: 4,
  },
};

export const politicaPrivacidadeStyles = {
  container: {
    px: ["4", "10", "20"],
    mt: "20",
  },
  mainFlex: {
    direction: "column",
    alignItems: "flex-start",
    gap: [8, 20],
  },
  content: {
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: 2,
  },
};

export const linksUteisStyles = {
  container: {
    maxWidth: "container.md",
    py: 10,
    centerContent: true,
  },
  box: {
    textAlign: "center",
    width: "100%",
  },
  stack: {
    mt: 6,
    width: "100%",
    align: "center",
    px: ["4", "0"],
  },
  card: {
    boxShadow: "sm",
    borderRadius: "8px",
    bg: "white",
    width: "100%",
    maxWidth: "1000px",
    mb: 2,
    transition: "all 0.5s ease",
    _hover: {
      bg: "gray.100",
      transform: "scale(1.04)",
    },
  },
  grid: {
    templateColumns: { base: "1fr", md: "1fr 2fr 1fr" },
    gap: 6,
    alignItems: "center",
    width: "100%",
  },
  nextImage: {
    width: "100%",
    height: "160px",
    paddingLeft: "10px",
    borderRadius: "8px",
  },
  chakraImage: {
    bg: "red",
    borderLeftRadius: "lg",
    objectFit: "cover",
    pl: "10",
  },
  linkName: {
    color: "gray.600",
    fontWeight: "bold",
    fontSize: "xl",
    fontFamily: "merriweather",
  },
  linkUrl: {
    color: "gray.600",
    fontSize: "sm",
  },
  iconBox: {
    display: "flex",
    justifyContent: "center",
  },
};

// Estilos atualizados para o sumário com animações e transições
export const sobreStyles = {
  container: {
    maxWidth: "100%",
    px: ["4", "8", "20"],
    mt: ["10", "10"],
  },
  flexContainer: {
    direction: ["column", null, "row"],
    gap: 10,
  },
  box: {
    flex: "3",
  },
  heading: {
    color: "gray.800",
    fontFamily: "merriweather",
    fontWeight: 700,
    mb: 1,
  },
  subheading: {
    fontWeight: "bold",
    fontSize: "lg",
    color: "gray.600",
    mb: 12,
  },
  sectionHeading: {
    color: "red-wine",
    mb: 6,
    pb: 2,
    borderBottom: "2px solid",
    borderColor: "gray.200",
    fontFamily: "merriweather",
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
  },
  sectionText: {
    fontSize: "md",
    lineHeight: "tall",
    textAlign: "justify",
    color: "gray.700",
    mr: ["0", "30px"],
  },
  imageContainer: {
    flex: ["1 1 45%", "1"],
    overflow: "hidden",
    transition: "all 0.5s",
    mx: "2",
    boxShadow: "lg",
    lineHeight: "0",
    borderRadius: "md",
    _hover: { flex: "1 1 25%" },
  },
  image: {
    objectFit: "cover",
    transition: "all 0.5s",
    _hover: {
      width: "100%",
      height: "100%",
    },
  },
  iconSpacing: { mr: 2 },
  boxBottomBorder: {
    p: "2",
    borderBottom: "2px solid",
    borderColor: "gray.200",
  },
};

// Estilos para o sumário com opção de minimizar
export const summaryStyles = {
  textSummary: {
    cursor: "pointer",
    transition: "all 0.2s",
    _hover: {
      bg: "red.50",
      color: "red.700",
    },
    width: "100%",
    alignItems: "center",
    px: 3,
    py: 2,
    borderRadius: "md",
  },
  sidebar: {
    position: "sticky",
    top: "150px",
    p: 4,
    bg: "gray.50",
    borderRadius: "lg",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    height: "fit-content",
    display: ["none", "block"],
    transition: "all 0.3s ease-in-out",
    borderRight: "1px solid",
    borderColor: "gray.100",
    zIndex: 10,
    overflow: "hidden",
  },
  summaryHeading: {
    fontSize: "lg",
    fontWeight: 600,
    mb: 2,
    color: "gray.700",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    ml: "10px",
  },
  summaryList: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  summaryItem: {
    px: 4,
    py: 2,
    borderRadius: "md",
    fontSize: "md",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    _hover: {
      bg: "red.50",
      color: "red.700",
    },
  },
  activeItem: {
    bg: "red.50",
    color: "red.700",
    borderLeft: "4px solid",
    borderLeftColor: "red.700",
    fontWeight: 600,
  },
  collapseButton: {
    position: "absolute",
    right: "-12px",
    top: "50%",
    transform: "translateY(-50%)",
    borderRadius: "full",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.15)",
    bg: "white",
    color: "red.700",
    borderWidth: "1px",
    borderColor: "gray.200",
    zIndex: 10,
    _hover: {
      bg: "red.50",
    },
  },
  iconButton: {
    color: "red.700",
    bg: "transparent",
    border: "none",
    transition: "all 0.2s ease-in-out",
    _hover: {
      background: "red.100",
    },
  },
};

